import { DTO } from "./dto.js";
import { CarreraBasicaDTO } from "./CarreraBasica.dto.js";

export class MateriaDTO extends DTO {
    constructor() {
        super();
        this.nombre = "";
        this.carrera = new CarreraBasicaDTO();// CarreraBasicaDTO
    }

    cargarDTO(dto) {
        super.cargarDTO(dto);

        if (dto.nombre !== undefined) { this.nombre = dto.nombre; }
        if (dto.carrera !== undefined) { this.carrera = new CarreraBasicaDTO(); this.carrera.cargarDTO(dto.carrera); }
    }

    clone(dto) {
        super.clone(dto);

        dto.nombre = this.nombre;
        dto.carrera = this.carrera;
    }
}
